import makeCountry from "./make_countries";

export default makeCountry(true);
